<template>
<v-container grid-list-xl text-xs-center elevation-1>
  <v-layout row wrap>
    <v-flex xs8 offset-xs2>
      <div style="text-align:center">
        <h1 class="action-title" v-bind:class="animation">{{ edit ? `${$t('user.edit.edit-title')}` : `${$t('user.edit.view-title')}`}} {{ user.username}}</h1>

        <v-btn class="btn-user-edit" v-on:click="editUser()" block :color="btnColorClass" slot="activator">
          <v-icon v-if="edit">mdi-account</v-icon>
          <v-icon v-if="!edit">mdi-account-edit</v-icon>
        </v-btn>


        <div v-bind:class="animationForm" v-if="!edit">
          <v-text-field v-model="baseUserData.username" :label="`${$t('user.username')}`" data-vv-name="name" readonly>
          </v-text-field>

          <v-text-field v-model="baseUserData.name" :label="`${$t('user.name')}`" data-vv-name="name" readonly>
          </v-text-field>

          <v-text-field v-model="baseUserData.surname" :label="`${$t('user.surname')}`" data-vv-name="name" readonly>
          </v-text-field>


          <v-text-field v-model="baseUserData.email" :label="`${$t('user.email')}`" data-vv-name="email" readonly>
          </v-text-field>

          <v-text-field v-model="baseUserData.phone" :label="`${$t('user.phone')}`" data-vv-name="phone" readonly>
          </v-text-field>

          <v-text-field :value="teamName" :label="`${$t('user.team')}`" readonly>
          </v-text-field>

          <v-text-field :value="departmentName" :label="`${$t('department.name')}`" readonly>
          </v-text-field>

          <v-text-field :value="agencyName" :label="`${$t('agency.agency')}`" readonly>
          </v-text-field>

          <v-text-field :value="baseUserData.lang" :label="`${$t('base.lang')}`" readonly>
          </v-text-field>

          <v-text-field :value="userRole" :label="`${$t('user.role')}`" readonly>
          </v-text-field>

          <v-text-field :value="baseUserData.created_at | timestampToDate" :label="`${$t('user.created-at')}`" readonly>
          </v-text-field>

          <v-text-field :value="baseUserData.updated_at | timestampToDate" :label="`${$t('user.update-at')}`" readonly>
          </v-text-field>

          <v-text-field :value="baseUserData.status==10 ? `${$t('user.status-type.active')}` : `${$t('user.status-type.inactive')}`" label="Status" readonly>
          </v-text-field>

          <div :style="getColorIconStyle(baseUserData.calendar_color)" ></div>
          <v-text-field :value="baseUserData.calendar_color" label="Kolor" readonly>
          </v-text-field>

          <v-switch v-model="baseUserData.auth_sms" class="ma-2" label="Autoryzacja SMS" readonly>
          </v-switch>
          <v-btn ref="regeneratePassword" v-if="Settings.generateNewPasswordAvallible()" @click="generateNewPassword()">Generuj nowe hasło</v-btn>
        </div>


        <v-form v-bind:class="animationForm" v-if="edit" ref="userEditForm">
          <v-text-field v-model="user.username" :label="`${$t('user.username')}`" data-vv-name="name">
          </v-text-field>
          <v-text-field v-model="user.email" :rules="emailRules" :label="`${$t('user.email')}`" data-vv-name="email" required>
          </v-text-field>
          <v-text-field v-model="user.phone" :label="`${$t('user.phone')}`" data-vv-name="phone" required>
          </v-text-field>
          <v-text-field v-model="user.name" :label="`${$t('user.name')}`" data-vv-name="name" :rules="surenameRules" required>
          </v-text-field>

          <v-text-field v-model="user.surname" :label="`${$t('user.surname')}`" :rules="surenameRules" data-vv-name="name" required>
          </v-text-field>
          <v-select v-model="user.role" :items="roles" item-text="name" item-value="value" :label="`${$t('user.role')}`" required>
          </v-select>

          <v-select v-model="user.team_id" :items="teams.filter(team => team.assign_hidden == 0)" item-text="name" item-value="id" :label="`${$t('user.team')}`" :rules="teamRules">
          </v-select>

          <v-select v-model="user.department_id" :items="departments" item-text="name" item-value="id" :label="`${$t('department.name')}`">
          </v-select>

          <v-select v-model="user.agency_id" :items="agencies" item-text="name" item-value="id" :label="`${$t('agency.agency')}`">
          </v-select>

          <v-select v-model="user.lang" :items="langs"  :label="`${$t('base.lang')}`">
          </v-select>

          <v-layout v-if="acl.isAllowed('canSetPassword')"  row wrap>
            <v-flex xs12 class="relative-flex">
              <v-text-field class="passwod-input"  v-model="user.password" :label="`${$t('user.password')}`" :rules="passwordRules" :required="changePass" :disabled="!changePass">
              </v-text-field>

              <div class="edit-pen">
                <v-icon v-bind:class="{ success: changePass }" v-on:click="changePass=!changePass">create</v-icon>
              </div>

            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="acl.isAllowed('canSetPassword')">
            <v-flex xs12>
              <v-text-field v-model="user.passwordR" :disabled="!changePass" :label="`${$t('user.confirm-password')}`"
                            :readonly="!changePass" :required="changePass" :rules="confirmPasswordRules"
                            class="rep-passwod-input">
              </v-text-field>
            </v-flex>
          </v-layout>

          <div id="user-color">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <div :style="getColorIconStyle(hexColor)" ></div>
                <v-text-field label="Kolor" v-model="hexColor" v-on="on" class="schema-name-input"></v-text-field>
              </template>

              <v-container style="background-color: #ffffff">
                <color-picker v-bind="color" @input="(hue) => onInput(hue,(hexcolor) => user.calendar_color = hexcolor)"></color-picker>
              </v-container>
            </v-menu>
          </div>

          <v-switch v-model="user.auth_sms" class="ma-2" label="Autoryzacja SMS"></v-switch>
          <v-btn :disabled="loading" @click="submit">submit</v-btn>

        </v-form>


      </div>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker';
import http from '@/plugins/http'
import Role from '@/plugins/Role'
import UserRules from '@/mixins/UserRules'
import _ from 'lodash'
import Acl from "@/plugins/Acl";
import langs from "@/plugins/langs";
import Messenger from "@/plugins/Messenger";
import Settings from "@/plugins/Settings";
export default {
  components: { ColorPicker },
  mixins: [UserRules, Color],
  data() {
    return {
      passwordRules: [v => (!!v || !this.changePass) || this.$t('user.create.error.empty-pass')],
      confirmPasswordRules: [v => (v === this.user.password || !this.changePass) || this.$t('user.create.error.pass-not-matching')],
      surenameRules: [v => !!v || this.$t('user.create.error.incorrect-surname')],
      teamRules: [v => {
        if (["worker", "leader"].indexOf(this.user.role) != -1 && !v) {
          return this.$t('user.create.error.no-team-for-leader')
        }
        return true
      }],
      user: {},
      teams: [],
      Settings: Settings,
      baseUserData: {},
      btnColorClass: "success",
      animation: "right-animation",
      animationForm: "left-animation",
      changePass: false,
      edit: false,
      loading: true,
      roleObj: new Role(),
      allRoles: [],
      departments: [],
      agencies :[],
      acl: new Acl(),
      langs : langs.getSupportedLangs()
    }
  },
  computed: {
    teamName() {
      if (this.teams != undefined && this.teams.length > 0 && this.baseUserData.role != undefined && this.baseUserData.team_id != undefined) {
        return _.find(this.teams, team => team.id == this.baseUserData.team_id).name
      }
      return ""
    },
    departmentName() {
      if (this.departments != undefined && this.departments.length > 0 && this.baseUserData.department_id != undefined) {
        return _.find(this.departments, department => department.id == this.baseUserData.department_id).name
      }
      return ""
    },
    agencyName() {
      if (this.agencies != undefined && this.agencies.length > 0 && this.baseUserData.agency_id != undefined) {
        return _.find(this.agencies, agency => agency.id == this.baseUserData.agency_id).name
      }
      return ""
    },
    roles() {
      return this.allRoles.map(r => ({
        "name": this.roleObj.translateRole(r.name),
        "value": r.name
      }))
    },
    userRole() {
      if (this.baseUserData.role != undefined) {
        return this.roleObj.translateRole(this.baseUserData.role)
      }
      return "";
    }
  },
  created() {
    this.loadTeams()
    this.loadUsers()
    this.loadAgencies()
    this.loadRoles()
    this.loadDepartments()
  },
  methods: {
    submit() {
      if (this.$refs.userEditForm.validate()) {

        let sendData = {}
        if (this.user.username != this.baseUserData.username) {
          sendData.username = this.user.username
        }
        if (this.user.email != this.baseUserData.email) {
          sendData.email = this.user.email
        }
        if (this.user.team_id != undefined && this.baseUserData.team_id != this.user.team_id) {
          sendData.team_id = this.user.team_id
        }
        if (this.user.department_id != undefined && this.baseUserData.department_id != this.user.department_id) {
          sendData.department_id = this.user.department_id
        }
        if (this.user.agency_id != undefined && this.baseUserData.agency_id != this.user.agency_id) {
          sendData.agency_id = this.user.agency_id
        }
        if (this.user.role != undefined && this.baseUserData.role != this.user.role) {
          sendData.role = this.user.role
        }
        if (this.changePass) {
          sendData.password = this.user.password
        }
        if (this.user.name != undefined && this.baseUserData.name != this.user.name) {
          sendData.name = this.user.name
        }
        if (this.user.surname != undefined && this.baseUserData.surname != this.user.surname) {
          sendData.surname = this.user.surname
        }
        if (this.user.phone != undefined && this.baseUserData.phone != this.user.phone) {
          sendData.phone = this.user.phone
        }
        if (this.user.auth_sms != undefined && this.baseUserData.auth_sms != this.user.auth_sms) {
          sendData.auth_sms = this.user.auth_sms
        }
        if (this.user.lang != undefined && this.baseUserData.lang != this.user.lang) {
          sendData.lang = this.user.lang
        }
        if (this.user.calendar_color != undefined && this.baseUserData.calendar_color != this.user.calendar_color) {
          sendData.calendar_color = this.user.calendar_color
        }

        this.loading = true;
        sendData.idUser = this.$route.params.idUser;

        this.$store.dispatch("updateUser", sendData).then(() => {
          this.$store.commit("setSnack", {
            message: this.$t("user.edit.success-message", {
              username: this.username
            }),
            color: "success"
          })
          this.loadUsers();
          this.edit = false;
        }).finally(() => {
          this.loading = false
        })
      }
    },
    generateNewPassword(){
      this.$confirm("Jesteś pewien?").then(res =>{
        if(res) {
          this.$refs.regeneratePassword.disabled = true
          this.$http.post('user/' + this.$route.params.idUser + '/generate-new-password').then(() => {
            Messenger.emitSuccess("Ok")
          }).catch(() => "Błąd")
        }
      })
    },
    loadUsers() {
      this.loading = true
      http.get('user/' + this.$route.params.idUser)
        .then(({
          data
        }) => {
          this.baseUserData = Object.assign({}, data);
          this.hexColor = this.baseUserData.calendar_color
          this.user = data
        })
      this.loading = false
    },
    loadTeams() {
      this.loading = true
      http.get('teams')
        .then(({
          data
        }) => {
          this.teams = data;
        })
      this.loading = false
    },
    loadRoles() {
      this.$http.get('rbac/roles').then(data => this.allRoles = data.data)
    },
    loadDepartments() {
      this.$http.get('departments').then(data => this.departments = data.data)
    },
    loadAgencies() {
      this.$http.get('agencies').then(data => this.agencies = data.data)
    },
    editUser() {
      if (!this.edit) {
        this.edit = true;
        this.btnColorClass = "primary"
        this.animation = "left-animation"
        this.animationForm = "right-animation"
      } else {
        this.animation = "right-animation"
        this.edit = false;
        this.btnColorClass = "success"
        this.animationForm = "left-animation"
      }
    }
  },
}
</script>

<style scoped>
.btn-user-edit {
  margin-bottom: 3rem;
}

.passwod-input {
  margin-top: -0.7rem;
}

.rep-passwod-input {
  margin-top: -1.7rem;
}

.action-title {
  margin-bottom: 3rem;
}

.right-animation {
  animation-duration: 0.5s;
  animation-name: rightAnimation;
}

.left-animation {
  animation-duration: 0.5s;
  animation-name: leftAnimation;
}

.edit-pen {
  position: absolute;
  right: -1rem;
  top: 0.5rem
}

.relative-flex {
  position: relative;
}

@keyframes rightAnimation {
  0% {
    -webkit-transform: translateX(-50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes leftAnimation {
  0% {
    -webkit-transform: translateX(50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(-10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}
</style>
